import { Pipe, PipeTransform } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Pipe({
  name: 'disabledByProperty',
  standalone: true,
})
export class DisabledByPropertyPipe implements PipeTransform {
  transform(props: FormlyFieldConfig['props'], field: FormlyFieldConfig, property = 'removeDisabled'): boolean {
    return (
      (Object.hasOwn(props, property) && props[property]) ||
      (Object.hasOwn(field?.props, property) && field?.props?.[property])
    );
  }
}
